export enum AreaType {
    Country = 0,
    Region = 1,
    City = 2
}